import React from "react"

import SectionHeading from "components/section-heading"
import { Container, ContainerOrdered, ContainerUnordered } from "./styles"

const List = ({
  elRef,
  heading,
  bulletType = "None",
  children,
  buttonElement,
  dataId,
  hideOnPageLoad,
  ...props
}) => {
  const items = React.Children.toArray(children)
  const ListContainer =
    bulletType === "Number" || bulletType === "None" ? ContainerOrdered : ContainerUnordered

  return (
    <Container hideOnPageLoad={hideOnPageLoad} data-exp-id={dataId} ref={elRef} {...props}>
      <SectionHeading title={heading} />
      <ListContainer bulletType={bulletType}>
        {items.map((item) => (
          <li key={item.key}>{item}</li>
        ))}
      </ListContainer>
      {buttonElement}
    </Container>
  )
}

export default List
